export const TRANSLATION_PREFIX = "si.lead_gen_filters.topLevelDomain";
